<div class="term-and-condition">
  {{"desc.by.login.i.agree.with" | translate}}
  <span class="important-terms" (click)="onNavigate('tnc')">{{"label.terms" | translate}}</span>
  {{"label.and" | translate}}
  <span class="important-terms" (click)="onNavigate('privacyPolicy')">{{"label.privacy.policy" | translate}}</span>
</div>
